module.exports = __webpack_public_path__ + "static/media/ktu_logo.89427c59.png";